
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenAverageCurve {

    avgImpactDuration: number;
    avgImpactLevelNormalized: number;
    avgRecoveryDuration: number;
    avgTauFall: number;
    avgTauRise: number;
    ciImpactDurationMax: number;
    ciImpactDurationMin: number;
    ciImpactLevelMax: number;
    ciImpactLevelMin: number;
    ciRecoveryDurationMax: number;
    ciRecoveryDurationMin: number;
    countyName: string;
    countySize: number;
    coverageEndDate: moment.Moment;
    coverageStartDate: moment.Moment;
    datasetKey: string;
    fipsCode: string;
    impactLevel: number;
    impactLevelNormalized: number;
    periodKind: string;
    periodYear: number;
    sourceWorkbook: string;
    state: string;
    stdTauFall: number;
    stdTauRise: number;
    threshold: number;
    totalDataPoints: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genAverageCurve: GenAverageCurve);

    constructor( input?: GenAverageCurve ) {
        if ( input && typeof input !== 'number' ) {
            this.avgImpactDuration = input.avgImpactDuration; // float [number]
            this.avgImpactLevelNormalized = input.avgImpactLevelNormalized; // float [number]
            this.avgRecoveryDuration = input.avgRecoveryDuration; // float [number]
            this.avgTauFall = input.avgTauFall; // float [number]
            this.avgTauRise = input.avgTauRise; // float [number]
            this.ciImpactDurationMax = input.ciImpactDurationMax; // float [number]
            this.ciImpactDurationMin = input.ciImpactDurationMin; // float [number]
            this.ciImpactLevelMax = input.ciImpactLevelMax; // float [number]
            this.ciImpactLevelMin = input.ciImpactLevelMin; // float [number]
            this.ciRecoveryDurationMax = input.ciRecoveryDurationMax; // float [number]
            this.ciRecoveryDurationMin = input.ciRecoveryDurationMin; // float [number]
            this.countyName = input.countyName; // string [string]
            this.countySize = input.countySize; // float [number]
            if ( input.coverageEndDate && typeof input.coverageEndDate === 'string' ) {
                this.coverageEndDate = moment(input.coverageEndDate).utc();
            } else {
                this.coverageEndDate = input.coverageEndDate;
            }
            if ( input.coverageStartDate && typeof input.coverageStartDate === 'string' ) {
                this.coverageStartDate = moment(input.coverageStartDate).utc();
            } else {
                this.coverageStartDate = input.coverageStartDate;
            }
            this.datasetKey = input.datasetKey; // string [string]
            this.fipsCode = input.fipsCode; // string [string]
            this.impactLevel = input.impactLevel; // float [number]
            this.impactLevelNormalized = input.impactLevelNormalized; // float [number]
            this.periodKind = input.periodKind; // string [string]
            this.periodYear = input.periodYear; // int [number]
            this.sourceWorkbook = input.sourceWorkbook; // string [string]
            this.state = input.state; // string [string]
            this.stdTauFall = input.stdTauFall; // float [number]
            this.stdTauRise = input.stdTauRise; // float [number]
            this.threshold = input.threshold; // float [number]
            this.totalDataPoints = input.totalDataPoints; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenAverageCurve[] {
        if (arr && arr.map) {
          return arr.map(a => new GenAverageCurve(a));
        } else {
          return [];
        }
    }
}

